import { Sparkles } from "lucide-react"
import { Button } from "@/components/ui/Button"
import { cn } from "@/utils/Functions"
import { serviceCategories } from "../lib/data"

interface FindHelpTabProps {
  onAction: (action: string) => void
}

export const FindHelpTab = ({ onAction }: FindHelpTabProps) => {
  return (
    <div className="max-w-5xl mx-auto max-h-[calc(100vh-24rem)] overflow-y-auto">
      <div className="text-center mb-8">
        <div className="mb-4 flex justify-center">
          <div className="p-4 bg-muted rounded-2xl border border-border">
            <Sparkles className="size-8 text-foreground/80" />
          </div>
        </div>
        <h2 className="text-3xl font-bold text-foreground mb-3">Find the Right Person</h2>
        <p className="text-muted-foreground text-lg">Get matched with trusted professionals in the music industry</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {serviceCategories.map((category) => (
          <button
            key={category.id}
            onClick={() => onAction(`Find ${category.name}`)}
            className={cn(
              "group relative p-6 rounded-2xl border-2 text-left transition-all",
              "bg-gradient-to-br backdrop-blur",
              category.color,
              category.borderColor,
              "hover:scale-105 hover:shadow-2xl cursor-pointer"
            )}
          >
            <category.icon className="size-8 text-foreground/80 mb-3" />
            <h3 className="text-foreground font-semibold text-lg mb-2">{category.name}</h3>
            <p className="text-muted-foreground text-sm">{category.description}</p>
          </button>
        ))}
      </div>

      <div className="bg-card border border-border rounded-2xl p-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="p-2 bg-muted rounded-lg">
            <Sparkles className="size-5 text-foreground/80" />
          </div>
          <div className="flex-1">
            <h3 className="text-foreground font-semibold mb-1">Describe what you need</h3>
            <p className="text-muted-foreground text-sm">Tell me what you're looking for and I'll help you find the perfect match</p>
          </div>
        </div>
        <textarea
          placeholder="e.g., I need an entertainment lawyer who specializes in recording contracts and has experience working with independent artists..."
          className="w-full h-32 px-4 py-3 bg-muted/50 border border-border rounded-xl text-foreground placeholder:text-muted-foreground/50 resize-none focus:outline-none focus:border-ring transition-colors"
        />
        <div className="flex items-center justify-between mt-4">
          <p className="text-muted-foreground text-sm">Get personalized recommendations from our network</p>
          <Button onClick={() => onAction("AI Match")}>
            <Sparkles className="size-4 mr-2" />
            Find Match
          </Button>
        </div>
      </div>
    </div>
  )
}
